export default {
  '校园风采':'Campus Style',
  '分类':'Category',
  '是否启用':'Enable/Disable',
  '内容列表':'Content List',
  '编辑名称':'Edit Name',
  '确认要开启{title}吗？':'Are you sure you want to enable {title}?',
  '确认要关闭{title}吗？':'Are you sure you want to disable {title}?',
  '确认要停用吗？':'Are you sure you want to deactivate?',
  '确认要删除吗？':'Are you sure you want to delete?',
  '内容':'Content',
  '标题':'Title',
  '支持jpg/jpeg/png格式，建议比例为1:1，最大不超过5M':'Upload Cover Image (JPG/JPEG/PNG, 1:1 ratio, max 5MB)',
}
